module.exports = __webpack_public_path__ + "assets/img/kv-d7ca72e4.png";